export default __webpack_public_path__ + "static/media/FileIcon.e02d04a6.svg";